module.exports = __webpack_public_path__ + "media/colleges/college_search_headline-01d1d9d4.png";